<template>
  <div class="form-check">
    <div class="checkbox-wrapper-40">
      <label>
        <input
          :id="checkboxId"
          :checked="agree"
          type="checkbox"
          value=""
          @change="$emit('update:agree', $event.target.checked)"
        >
        <span class="checkboxContent">
          <!--eslint-disable-next-line-->
            <p v-html="agreeTip" />
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreeCheckbox',
  props: {
    agree: {
      type: Boolean,
      default: false
    },
    agreeTip: {
      type: String,
      default: ''
    },
    checkboxId: {
      type: String,
      default: 'withdraw-agree'
    }
  }
}
</script>
